import { useSearchParams, Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { useClient } from '@/modules/clients/hooks/useClient'
import { usePointMutation } from '@/modules/points/hooks/usePointMutation'
import { RedeemPointForm } from '@/modules/points/components/RedeemPointForm'
import { ErrorState } from '@/shared/components/ui/atoms/ErrorState'

export function RedeemPointPage() {
  const [searchParams] = useSearchParams()
  const clientId = Number(searchParams.get('clientId'))
  const { data: client, status: clientStatus, isLoading, error: loadError } = useClient(clientId)
  const { createPoint, isSubmitting, error: mutationError } = usePointMutation()

  if (!clientId) {
    return (
      <ErrorState message="No se especifico un cliente. Navega desde el detalle del cliente." />
    )
  }

  if (isLoading) {
    return <div className="animate-pulse h-96 bg-gray-100 rounded-lg" />
  }

  if (loadError) {
    return <ErrorState message={loadError} />
  }

  if (!client) return null

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <Link to={`/clients/${clientId}`} className="text-gray-500 hover:text-gray-700">
          <ArrowLeft size={20} />
        </Link>
        <h1 className="text-2xl font-bold text-gray-900">Canjear Puntos</h1>
      </div>
      <div className="card p-6">
        <RedeemPointForm
          client={client}
          clientStatus={clientStatus}
          onSubmit={createPoint}
          isSubmitting={isSubmitting}
          error={mutationError}
        />
      </div>
    </div>
  )
}
